a.checkout.checkin = (function(){
	var my = {
		popup:function(o){
			var cid = o.cid || undefined;
			var f_close = o.close || function(){};
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Check in',
				css_class:'',
				ready:function(token){
					my.loadInitContent(token,cid,f_close);
				}
			});
		},
		loadInitContent:function(token,cid,cb_close){
			var area = $('#popupid_'+token);
			// Load item
			$.ajax({
				type:'GET',
				url:'/api/checkout/load/',
				data:{
					cid:cid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						tpl.run({
							tpl:'/tpl/checkout/checkin/popup.ejs?v='+v,
							data:result,
							cb:function(c){
								$('#popupid_'+token+'>.ic').empty().append(c);
								// Load item list
								var ipe = a.s.itempickerelement();
								ipe.el = $('div[data-area="itemlist"]',$('#popupid_'+token+'>.ic'));
								ipe.filter = {};
								ipe.readonly = true;
								ipe.custom_main_template = 'main_checkin';
								ipe.custom_template = 'listitem_checkin';
								ipe.show_complete_kits = false;
								ipe.iid_list = result.data.itemlist.map(obj => obj.iid);
								ipe.checkout_id = cid;
								ipe.insert();
								// Bind checkin button
								$('button[data-action="checkin"]',area).unbind('click').click(function(){
									my.checkIn(cid,area,token,cb_close);
									event.preventDefault();
								});
							}
						});
					}
					else {
						a.s.growl.create('Error','Unable to perform operation',{});
					}
				}
			});
		},
		checkIn:function(cid,area,token,cb_close){
			var itemlist = $.map($('input[name="itemlist[]"]:checked',area), function(c){return c.value; });
			var remarks_checkin = $('textarea[name="remarks_checkin"]',area).val();
			a.loader.fs.create();
			$.ajax({
				type:'POST',
				url:'/api/checkout/checkin/',
				data:{
					cid:cid,
					itemlist:itemlist,
					remarks_checkin:remarks_checkin,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						a.s.growl.create('Success','Selected items has been checked in',{});
					}
					else if (!result.success && result.errorlist) {
						result.errorlist.forEach(function(e){
							a.s.growl.create('Error',e,{});
						});
					}
					window.history.back();
					cb_close();
				}
			}).done(function(){
				a.loader.fs.remove();
			});
		}
	}
	return my;
}());